import ListaPrestacoes from './PrestacaoContas/ListaPrestacoes'
import PreHabilitadoTable from './PreHabilitadoTable'
import GraficoConsumo from './Consumo/GraficoConsumo'
import CriterioRemedio from './CriterioRemedio'
import OpenMap from './LeafletMap'
import CardEmendas from './CardEmendas'
import SideEmendas from './emendas/SideEmendas'
import SelectAno from './emendas/SelectAno'
import ProgressoCandidato from './EleicaoConselho/ProgressoCandidato'
import ProgressoGeral from './EleicaoConselho/ProgressoGeral'
import ListaCandidatos from './EleicaoConselho/ListaCandidatos'
import ListaCandidatosGeral from './EleicaoConselho/ListaCandidatosGeral'
import CardsODS from './CardsODS'
import CardsFiltro from './CardsODS/CardsFiltro.vue'
import InfoDados from './Dados/InfoDados'
import Downloads from './Dados/Downloads'
import Graficos from './Dados/Graficos'
import TabelaValores from './Dados/TabelaValores'
import CardsSecretaria from './CardsODS/CardsSecretaria'
import CardsFiltrosSecretaria from './Dados/CardsFiltrosSecretaria.vue'
import FaixaComparacao from './Dados/FaixaComparacao.vue'
import CardsPortais from './Panel/CardsPortais'
import ValorDestaque from './ValorDestaque'
import CardInstitucional from './Cards/InstitucionalNomeValor'

export {
  ListaPrestacoes,
  PreHabilitadoTable,
  GraficoConsumo,
  CriterioRemedio,
  OpenMap,
  CardEmendas,
  SideEmendas,
  SelectAno as SelectAnoEmendas,
  ProgressoCandidato,
  ProgressoGeral,
  ListaCandidatos,
  ListaCandidatosGeral,
  CardsODS,
  CardsFiltro,
  InfoDados,
  Downloads,
  Graficos,
  TabelaValores,
  CardsSecretaria,
  CardsFiltrosSecretaria,
  FaixaComparacao,
  CardsPortais,
  ValorDestaque,
  CardInstitucional
}

export * from './ProcedimentosSaude/index'
export * from './common'



// WEBPACK FOOTER //
// ./src/components/index.js